<template>
    <tr class="lms__superadmin_workspaces_edit_apiintegration_table_item">
        <td class="lms__superadmin_workspaces_edit_apiintegration_table_name">
            <div class="columns is-vcentered">
                <div class="column">{{ keyName }}</div>
                <template v-if="keyStatus === 'active'">
                    <div class="column is-narrow">
                        <component-button
                            :name="'lms-superadmin-workspace-edit-apiintegration-table-item-copy-apikey'"
                            :icon="true"
                            :icon-name="'copy'"
                            :icon-raw="true"
                            :theme="''"
                            @click="handleCopyToClipboard(keyApiKey, 'key')"
                        >
                        </component-button>
                    </div>
                </template>
            </div>
        </td>
        <td class="lms__superadmin_workspaces_edit_apiintegration_table_createdat">
            {{ keyCreatedAtDate }}
        </td>
        <td class="lms__superadmin_workspaces_edit_apiintegration_table_status">
            <component-status
                :status="keyStatus"
            />
        </td>
        <td class="lms__superadmin_workspaces_edit_apiintegration_table_actions">
            <div class="columns is-variable">
                <div class="column"></div>
                <template v-if="keyStatus === 'active'">
                    <div class="column is-narrow">
                        <component-button
                            :name="'lms-superadmin-workspace-edit-apiintegration-table-item-edit-action'"
                            :theme="'default'"
                            @click="performEmit('emit-edit', keyId)"
                        >Edit
                        </component-button>
                    </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>

import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import ComponentText from '@/components/default/shared/ComponentText'
import { toLocaleDateTime } from '@/functions'

export default {
  name: 'lms-superadmin-workspace-edit-api-integration-table-item',
  components: { ComponentText, ComponentButtonMenu, ComponentButton, ComponentStatus },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    }
  },
  computed: {
    keyApiKey () {
      return this.item.apiKey
    },
    keyName () {
      const apiKey = JSON.parse(JSON.stringify(this.item.apiKey))
      let apiKeyArr = apiKey.split('')

      for (let index in apiKeyArr) {
        const indexNumber = Number(index) + 1
        const arrLength = apiKeyArr.length

        if (indexNumber > 7) {
          apiKeyArr[index] = 'x'
        }

        if (indexNumber && indexNumber % 5 === 0 && indexNumber !== arrLength) {
          apiKeyArr[index] += ' - '
        }
      }

      const apiKeyOutput = apiKeyArr.join('')

      return apiKeyOutput
    },
    keyCreatedAtDate () {
      return toLocaleDateTime(this.item.issuedAt)
    },
    keyId () {
      return this.item.id
    },
    keyStatus () {
      return this.item.status
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message, value })
    }
  }
}
</script>
